export const FEATURED_PROPERTY_SOURCES = {
  TRIVAGO: {
    text: 'on Trivago',
    color: 'white',
    background: 'external.trivago',
  },
  TRIPADVISOR: {
    text: 'on TripAdvisor',
    color: 'white',
    background: 'external.tripAdvisor',
  },
  GOOGLEHOTELS: {
    text: 'on Google',
    color: 'white',
    background: 'external.google',
  },
  EMAIL: {
    text: 'from your Email',
    color: 'greys.charcoal',
    background: 'brand.secondary',
  },
  DEFAULT: {
    text: '',
    color: 'greys.charcoal',
    background: 'brand.secondary',
  },
};
